// cherrypick functions
import { toggleAccordions } from "./components/accordion"
import "./components/nav"
import "./components/filters"
import "./components/code-block"
import "./components/catalogue-search/initiate"
import "./components/data-catalogue-dictionary/initiate"
import { initAccordionTracking, initAccordionLinkTracking, reinitAccordionTracking } from "./accordion-tracking"
import { initFormTracking, initFormObserver } from "./form-tracking"
// import { trapFocus } from "./helpers/trapFocus"

/* LOAD SCRIPTS */
document.addEventListener("DOMContentLoaded", () => {
    // ACCORDION
    const accordionButtons = document.querySelectorAll(".js-accordion-btn")
    if (accordionButtons) {
        toggleAccordions(accordionButtons)
    }

    const isTrackingEnabled = window.enableTracking === true

    // GTM TRACKING
    if (isTrackingEnabled) {
        initAccordionTracking()
        initAccordionLinkTracking()
        initFormTracking()
        initFormObserver()

        // Expose re-init for dynamically loaded content
        window.reinitAccordionTracking = reinitAccordionTracking
    } else {
        window.reinitAccordionTracking = () => {}
    }

    /* begin begin Back to Top button  */
    const goTopBtnContainer = document.querySelector(".back-to-top")
    // const goTopBtn = goTopBtnContainer.querySelector(".btn--back-to-top")
    if (goTopBtnContainer) {
        ;(function () {
            "use strict"

            function trackScroll() {
                let scrolled = window.pageYOffset
                const coords = document.documentElement.clientHeight

                if (scrolled > coords) {
                    goTopBtnContainer.classList.add("back-to-top--visible")
                }
                if (scrolled < coords) {
                    goTopBtnContainer.classList.remove("back-to-top--visible")
                }
            }

            // function backToTop() {
            //     if (window.pageYOffset > 0) {
            //         document.body.scrollTop = 0 // For Safari
            //         document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
            //     }
            // }

            window.addEventListener("scroll", trackScroll)
            // goTopBtn.addEventListener("click", backToTop)
        })()
    }

    /* end begin Back to Top button  */
})
